<template>
  <v-app id="app"
    class="app"
    v-show="!platform.prerenderer && isReady"
    :class="[{'border-expanded': isBorderExpanded},
      {'video-call': isVideoCall},
      {'hotspot-open': isHotspotOpen},
      {'hotspot-open': isMapOpen},
      {'portrait': viewPort.width < viewPort.height}]"
  >

    <div v-if="isReady">
      <Header v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded" />

      <Panolens360
        v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded && $route.name === 'Room'"
        ref="pano"
      />

      <AudioguideModal v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded" />

      <HotspotOverlayContent v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded && !isLoading"/>
      <HotspotOverlayMultiProduct v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded && !isLoading"/>

      <FloorMap v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded" v-show="!isLoading" />

      <transition name="fade">
        <router-view
          v-if="isAllSiteSettingsLoaded && isAllTranslationsLoaded"
        />
      </transition>

      <!--<BannerCookie v-if="!$root.isApp && !$root.isTmall && isAllSiteSettingsLoaded && isAllTranslationsLoaded"></BannerCookie>-->
    </div>
    <!-- Loading -->
    <transition name="fade" appear>
      <Preloader
        v-show="isLoading"
        :isIntro="$route.name === 'Home'"
        :isBig="$route.name === 'Home'"
      />
    </transition>

    <!--<VersionInfo
      v-if="!$root.platform.mobile && $root.process.env.SERVICE_STAGE !== 'production'"
      :version="$root.process.env.GIT_VERSION"
      :commit-hash="$root.process.env.GIT_COMMIT_HASH"
      />-->

    <RotateDevice v-if="isReady && isAllTranslationsLoaded"></RotateDevice>
  </v-app>
</template>

<script>
// import CookiePolicy from './organisms/CookiePolicy.vue'
import Preloader from './organisms/Preloader.vue'
// import BannerCookie from './atoms/BannerCookie.vue'
import RotateDevice from './organisms/RotateDevice.vue'
// import SmokeCanvas from './atoms/SmokeCanvas.vue'
import HotspotOverlayContent from './molecules/HotspotOverlayContent.vue'
import HotspotOverlayMultiProduct from './molecules/HotspotOverlayMultiProduct.vue'
import FloorMap from './molecules/FloorMap.vue'
import { Viewport } from '@monogrid/vue-lib'
import { Platform } from '@monogrid/js-utils'
import shareImage from '@/assets/img/share.jpg'
import Panolens360 from '@/molecules/Panolens360'

import SiteSetting from '@/graphql/GetSiteSetting.gql'
import ListTranslation from '@/graphql/ListTranslation.gql'

import Header from '@/organisms/Header.vue'
import AudioguideModal from '@/atoms/AudioguideModal.vue'

export default {
  name: 'App',

  mixins: [Viewport],

  components: {
    Panolens360,
    Header,
    FloorMap,
    HotspotOverlayContent,
    // SmokeCanvas,
    HotspotOverlayMultiProduct,
    RotateDevice,
    // BannerCookie,
    Preloader,
    AudioguideModal
    // CookiePolicy
  },

  data: function () {
    return {
      /* Preloader */
      isLoading: true,
      isHotspotOpen: false,
      isMapOpen: false,
      isApp: false,
      isBorderExpanded: false,
      showCloudAnimation: false,
      // this flag is used to show the app once the preloading
      // (if present) is finished
      isReady: false,
      isAllSiteSettingsLoaded: false,
      isAllTranslationsLoaded: false,
      // platform, accessible with an import statement
      // or by using this.$root.platform
      // NOTE: import statement is preferred
      platform: Platform
    }
  },

  mounted: function () {
    this.checkRoute()

    // set this.isReady = true
    // when all stuff that needs to be loaded for the app is loaded
    // if you need to preload stuff, delete this line and set to true later
    this.isFirstTutorial = false
    this.isReady = true
    /* Preloader */
    this.$events.on('isLoadingStart', () => {
      this.isLoading = true
    })
    this.$events.on('isLoadingEnd', () => {
      this.isLoading = false
    })

    this.$events.on('onMapOpen', () => { this.isMapOpen = true })
    this.$events.on('onMapClose', () => { this.isMapOpen = false })

    this.$events.on('onBorderExpanded', (e) => { this.isBorderExpanded = e })

    if (this.$root.platform.ios) {
      document.addEventListener('touchmove', function (event) {
        event = event.originalEvent || event
        if (event.scale !== 1) {
          event.preventDefault()
        }
      }, { passive: false })
    }
  },

  // Query
  apollo: {
    // Site settings
    SiteSetting: {
      query: SiteSetting,
      variables: { status: 'PUBLISHED', slug: 'gucci-garden-virtual-tour' },
      async result () {
        this.$root.allSettings = this.SiteSetting
        // console.log('Settings loaded', this.$root.allSettings)
        this.isAllSiteSettingsLoaded = true
      }
    },
    // All translations
    Translations: {
      query: ListTranslation,
      async result () {
        this.$root.allLanguages = {}
        for (let i = 0; i < this.Translations.items.length; i++) {
          const element = this.Translations.items[i]
          this.$root.allLanguages[element._slug] = element
        }
        // console.log('Translation loaded', this.$root.allLanguages)
        // console.log('DEBUG: CURRENT LANG TRANSLATIONS:', this.$root.allLanguages[this.$route.params.language])

        this.isAllTranslationsLoaded = true
      }
    }
  },

  methods: {
    checkRoute () {
      if (this.$route.query.app) {
        this.$root.isApp = true
      }

      if (this.$route.query.screenshot) {
        this.$root.isScreenshot = true
      }

      /* if (this.$route.query.tmall) {
        this.$root.isTmall = true
      } */

      if (this.showAudioGuideModal) {
        this.showAudioGuideModal = false
      }
    }
  },

  computed: {
    isVideoCall () {
      let videoCallShow = false
      if (this.$route.params.roomName) {
        if ((this.$route.params.roomName.indexOf('boutique') > -1 || this.$route.params.roomName.indexOf('bookstore') > -1) && !this.isLoading) {
          videoCallShow = true
        }
      } else {
        videoCallShow = false
      }

      return videoCallShow
    }
  },
  watch: {
    isAllSiteSettingsLoaded () {
      if (this.isAllSiteSettingsLoaded && this.isAllTranslationsLoaded) {
        if (this.$route.name !== 'Home') {
          this.isLoading = false
        }
      }
    },
    isAllTranslationsLoaded () {
      if (this.isAllSiteSettingsLoaded && this.isAllTranslationsLoaded) {
        if (this.$route.name !== 'Home') {
          this.isLoading = false
        }
      }
    },
    isReady: function (value) {
      // hide / show preloader
      this.$root.preloader.visible = !value
    },
    $route () {
      this.checkRoute()
      if (this.$route.name === 'Home') {
        this.showCloudAnimation = false
      }

      if (this.$route.params.hotspotContent) {
        this.isHotspotOpen = true
      } else {
        this.isHotspotOpen = false
      }
    }
  },

  metaInfo: function () {
    return {
      title: 'Gucci Garden Tour',
      base: { href: '/' },
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        // twitter
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@monogridstudio' },
        { name: 'twitter:creator', content: '@monogridstudio' },
        // generic description
        { vmid: 'description', name: 'description', content: '360 tour for Gucci Garden' },
        // og tags
        { vmid: 'ogtype', property: 'og:type', content: 'website' },
        { vmid: 'ogurl', property: 'og:url', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + '/' + this.$route.fullPath },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: 'Gucci Garden Tour' },
        { vmid: 'ogdescription', property: 'og:description', content: '360 tour for Gucci Garden' },
        { vmid: 'ogimage', property: 'og:image', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + shareImage },
        { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
        { vmid: 'ogimageheight', property: 'og:image:width', content: '1200' },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: '630' }
      ]
    }
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'Nitti';
  font-style: normal;
  font-weight: 700;
  src: url('assets/fonts/NittiGroteskBoldTT.woff2') format('woff'),
    url('assets/fonts/NittiGroteskBoldTT.woff') format('woff');
}

@font-face {
  font-family: 'Nitti';
  font-style: normal;
  font-weight: 400;
  src: url('assets/fonts/NittiGroteskNormalTT.woff2') format('woff'),
    url('assets/fonts/NittiGroteskNormalTT.woff') format('woff');
}

@font-face {
  font-family: 'Nitti';
  font-style: normal;
  font-weight: 500;
  src: url('assets/fonts/NittiGroteskMediumTT.woff2') format('woff'),
    url('assets/fonts/NittiGroteskMediumTT.woff') format('woff');
}

@font-face {
  font-family: 'Nitti';
  font-style: normal;
  font-weight: 300;
  src: url('assets/fonts/NittiGroteskLightTT.woff2') format('woff'),
    url('assets/fonts/NittiGroteskLightTT.woff') format('woff');
}

html,
body {
  // overflow: hidden !important;
  background-color: $c-pink;
}

.ios {
  body .v-application,
  .app {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}

body .v-application,
.app {
  background-color: $c-pink;
  color: $c-black !important;

  // overflow: hidden;
  transition: background-color 0.5s;

  font-family: 'Nitti';
  font-weight: 500;

  &.video-call ~ #cts-container { //stylelint-disable-line
    display: block !important; //stylelint-disable-line

    #cts-tab { //stylelint-disable-line
      bottom: 70px;
      right: 48px;

      @include breakpoint('md-and-down') {
        bottom: 70px;
        right: 8px;
      }

      @include breakpoint('xs-only') {
        bottom: 70px;
      }
    }
  }

  &.hotspot-open ~ #cts-container { //stylelint-disable-line
    display: none !important; //stylelint-disable-line
  }
}

#cts-container { //stylelint-disable-line
  display: none !important; //stylelint-disable-line
}

.monogrid-logo-svg {
  height: 40px;
  width: 167px;

  @include breakpoint('xs-only') {
    height: 20px;
    width: 83px;
  }

  path {
    fill: map-get($shades, 'white');
    stroke: map-get($shades, 'white');
  }
}

h1 {
  font-size: 66px;

  @include breakpoint('lg-and-down') {
    font-size: 56px;
  }

  @include breakpoint('md-and-down') {
    font-size: 44px;
  }

  @include breakpoint('xs-only') {
    font-size: 38px;
  }
}

h2 {
  font-size: 50px;
  font-weight: 500;

  @include breakpoint('lg-and-down') {
    font-size: 44px;
  }

  @include breakpoint('md-and-down') {
    font-size: 36px;
  }
}

h3 {
  font-size: 32px;
  line-height: 1.25;
  @include breakpoint('sm-and-down') {
    font-size: 24px;
  }
}

h4 {
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
}

p {
  font-size: 18px;
  line-height: 1.3;

  @include breakpoint('sm-and-down') {
    font-size: 16px;
  }

  &.xs {
    font-size: 16px;
  }

  &.xxs {
    font-size: 14px;
  }
}

a {
  color: $c-black;
}

.relative {
  position: relative;
}

.inline-block {
  display: inline-block;
}

.underline {
  text-decoration: underline;
}

.pointer {
  cursor: pointer;
}

.italic {
  font-style: italic;
}

.c-white {
  color: $c-white;
}

.capitalize {
  text-transform: capitalize;
}

.hover-letter-spacing {
  transition: letter-spacing 0.5s;

  &:hover {
    letter-spacing: 2px;
  }
}

.uppercase {
  text-transform: uppercase;
}

.medium {
  font-weight: 500 !important;
}

.bold {
  font-weight: 700 !important;
}

.regular {
  font-weight: 400 !important;
}

.light {
  font-weight: 300 !important;
}

.svg-fill-white {
  fill: $c-white;

  path {
    fill: $c-white;
  }
}

.svg-stroke-white {
  stroke: $c-white;

  path {
    stroke: $c-white;
  }
}

/* Loading */
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.text-align-center {
  text-align: center;
}

.text-align-left {
  text-align: left;
}

.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.pointer-none {
  pointer-events: none;
}

.center-absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.scale-enter-active,
.scale-leave-active {
  transition: transform 0.5s;
}

.scale-enter,
.scale-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}

.fade-slide-up-enter-active,
.fade-slide-up-leave-active {
  transition: opacity 1s;
}

.fade-slide-up-enter,
.fade-slide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.row + .row {
  margin-top: 0 !important;
}
</style>
